import React from 'react';

const SidebarElementHeader = ({text,handleBackClick}) => (
	<div className="header">
		<button type="button" onClick={handleBackClick} className="btn btn-primary btn-outline"><i className="icon wb-chevron-left"></i></button>
		<i className="icon wb-more-vertical"></i> {text}
	</div>
);

export default SidebarElementHeader;


// WEBPACK FOOTER //
// ./components/builder/SidebarElementHeader.js